import React from 'react'
import { Modal, type ModalProps } from '@mantine/core'

export type AppModalProps = ModalProps

/** Standard modal dialog with centered positioning and md radius. */
export default function AppModal ({ centered = true, radius = 'md', ...props }: AppModalProps) {
  return <Modal centered={centered} radius={radius} {...props} />
}
